module.exports = __webpack_public_path__ + "img/job-icon.bf5f289a.svg";